import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, useEffect, createElement, cloneElement } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import { useProxiedRef } from '../../utils/hooks/useProxiedRef.js';

var _excluded = ["button", "defaultValue", "icon", "highlighted", "state", "autoFocus"];
var Input = /*#__PURE__*/forwardRef(function Input(props, ref) {
  var _cn;

  var button = props.button,
      icon = props.icon,
      highlighted = props.highlighted,
      state = props.state,
      autoFocus = props.autoFocus,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var inputRef = useProxiedRef(ref);
  var hasContainer = button || icon;
  var classNames = cn('yt-input', (_cn = {}, _cn["yt-input--state-" + state] = !!state, _cn['yt-input--highlighted'] = highlighted, _cn), !hasContainer && otherProps.className);
  useEffect(function () {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  var input = createElement("input", Object.assign({}, otherProps, {
    className: classNames,
    ref: inputRef
  }));

  if (hasContainer) {
    var _extra$props$disabled;

    var extra;

    if (button) {
      extra = button;
    } else if (icon) {
      extra = createElement(Icon, {
        name: icon
      });
    }

    var containerClassName = cn('yt-input__container', otherProps.className);
    return createElement("div", {
      className: containerClassName
    }, input, cloneElement(extra, {
      disabled: (_extra$props$disabled = extra.props.disabled) !== null && _extra$props$disabled !== void 0 ? _extra$props$disabled : otherProps.disabled
    }));
  }

  return input;
});

export { Input };
//# sourceMappingURL=Input.js.map
